<!--reportForms 碳排放报表-->
<template>
  <div class="unitOverview">
    <span style="display:block;position: relative;">
      <img src="./22.png" alt="" style="width: 100%;" />
      <span class="clil">
        <div
          class="li"
          v-for="i in 10"
          @click="detail_status = !detail_status"
          :key="i"
        ></div>
      </span>
    </span>

    <el-dialog title="详情" v-dialogDrag :visible.sync="detail_status" center>
      <img src="./33.jpg" alt="" style="width: 100%;" />
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="detail_status = !detail_status"
            >确 定
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      detail_status: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.unitOverview {
  background-color: #edf0f4;
  padding: 20px;
  .clil {
    position: absolute;

    top: 34%;
    right: 3%;
    width: 5%;
    height: 58%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .li {
      width: 100%;
      height: 6%;
      cursor: pointer;
    }
  }
}
</style>
